var styleDataHash = "7cb202bd";
const injectCss = (() => {
  var css = `._3DskY{margin-left:0;margin-right:auto;z-index:1}._3DskY:not(._4eNM3){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){._3DskY:not(._4eNM3){float:none;margin-right:auto}}}@container (width < 480px){._3DskY:not(._4eNM3){float:none;margin-right:auto}}.oQakO{margin-left:auto;margin-right:0;z-index:1}.oQakO:not(._4eNM3){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.oQakO:not(._4eNM3){float:none;margin-left:auto}}}@container (width < 480px){.oQakO:not(._4eNM3){float:none;margin-left:auto}}.mC4Md{clear:both;display:block}.mC4Md:not(.ScPMr){margin-left:auto;margin-right:auto;max-width:100%}.ScPMr,._4eNM3{width:100%}.GMll4 .ScPMr,.GMll4 ._4eNM3{margin:0 -8px;width:auto}.JT-JT{width:fit-content}.ucTNz{margin-left:auto;margin-right:auto;max-width:100%}.-pWQs{width:min(350px,100%)!important}.GMll4 .-pWQs{width:50%}.cebA2{margin-left:auto;margin-right:auto}.GMll4 .cebA2{width:150px}.SQhDM{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "_3DskY",
  "textWrapNowrap": "_4eNM3",
  "alignRight": "oQakO",
  "alignCenter": "mC4Md",
  "sizeFullWidth": "ScPMr",
  "renderedInTable": "GMll4",
  "sizeOriginal": "JT-JT",
  "sizeContent": "ucTNz",
  "sizeSmall": "-pWQs",
  "sizeSmallCenter": "cebA2",
  "flex": "SQhDM"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
